module.exports = __webpack_public_path__ + "media/images/front/event/calendar-icon-f1dec556dd8138794bc0786d52666c6c.svg";